<script>
    import Fa from 'svelte-fa';
    import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

    import Button from '$lib/components/Button.svelte';

    import { page } from '$app/stores';
    import { goto } from '$app/navigation';
    import { browser } from '$app/environment';

    export let filters;
    export let selected;
    export let classes = '';

    // selected filter input=checkbox bind group. key contains data and value is true or false whether checked or not
    $: selectedFilters = selected || [];

    // create an array of filtered objects where the checkbox value is true and parse them
    $: selectedFilterObjects = Object.keys(selectedFilters)
        .filter((key) => selectedFilters[key] === true)
        .map((key) => JSON.parse(key));

    // convert the selectedFilterOptions array into a URL-safe string
    $: query = encodeURIComponent(JSON.stringify(selectedFilterObjects));

    // detection for filter changing
    let filterChanging = false;

    // navigate to filtered view if exists else return to home position
    $: if (browser && query && filterChanging) {
        filterChanging = false;
        const searchParams = new URLSearchParams($page.url.searchParams);
        searchParams.set('filter', query);
        goto(`${$page.url.pathname}${searchParams ? '?' : ''}${searchParams.toString()}`, { replaceState: true, noScroll: true });
    } else if (browser && !query && filterChanging) {
        filterChanging = false;
        goto(`${$page.url.pathname}`, { replaceState: false, noScroll: true });
    }

    // clear filter group button
    const clearFilterGroup = (filterId) => {
        filters
            .filter((filter) => filter.id === filterId)[0]
            .values.map((value) => {
                filterChanging = true;
                selectedFilters[value.input] = false;
            });
    };

    // build object of active filter groups to show filterType button as active
    $: activeFilterGroup = filters.reduce((accumulator, filter) => {
        let active = false;
        filter.values.forEach((value) => {
            if (selectedFilters[value.input]) {
                active = true;
            }
        });
        return { ...accumulator, [filter.id]: active };
    }, {});

    // filter draw show/hide based on filterId as value
    $: filterDrawerOpen = '';
</script>

<button
    class={`fixed left-0 top-0 z-20 h-screen w-screen bg-black/40 dark:bg-black/20
${filterDrawerOpen.length ? 'block' : 'hidden'}`}
    on:click={() => (filterDrawerOpen = '')}
/>

{#each filters as filter (filter.id)}
    {#if filter.values.length > 1}
        <div class="relative flex shrink-0">
            <button
                class={`
                    relative z-20 flex shrink-0 items-center justify-center rounded-full border border-color-text/40 bg-color-background px-5 py-1 text-sm
                    ${activeFilterGroup[filter.id] ? 'border-primary bg-primary text-white' : 'border-color-text/40 bg-color-background'} ${classes}
                `}
                on:click={() => (filterDrawerOpen = filter.id)}
            >
                {filter.label}
                <Fa icon={faChevronDown} size="0.8x" class="ml-1" />
            </button>

            <div
                class={`draw-bottom fixed bottom-0 left-0 z-30 min-h-[60vh] w-full rounded-t-xl bg-base-900 shadow-2xl lg:absolute lg:bottom-auto
                lg:left-0 lg:top-12 lg:block lg:min-h-0 lg:w-72 lg:overflow-hidden lg:rounded-xl lg:shadow-2xl
                ${filterDrawerOpen === filter.id ? 'open' : ''}`}
            >
                <div class="overflow-hidden rounded-t-xl bg-base-800 p-2">
                    <div class="text-center text-base font-semibold uppercase lg:text-sm">{filter.label}</div>
                    <p class="text-center text-sm lg:text-xs">You can select multiple</p>
                </div>
                <ul class="no-scrollbar max-h-[60vh] overflow-y-scroll pb-20 lg:max-h-96 lg:pb-0">
                    {#each filter.values as value (value.id)}
                        {#if value.count != 0}
                            <li class="relative">
                                <input
                                    class="absolute right-7 top-5"
                                    type="checkbox"
                                    id={value.id}
                                    name={value.id}
                                    bind:checked={selectedFilters[value.input]}
                                    on:change={() => {
                                        filterChanging = true;
                                    }}
                                />

                                <label for={value.id}>
                                    <div
                                        class="rounded-xs inline-block w-full cursor-pointer border-t
                                         border-color-text/10 px-7 py-4 hover:bg-base-800/40 lg:text-sm"
                                    >
                                        {value.label} ({value.count})
                                    </div>
                                </label>
                            </li>
                        {/if}
                    {/each}
                </ul>

                <div class=" absolute bottom-0 grid w-full grid-cols-12 items-center justify-center bg-base-800 p-3.5 text-center lg:relative">
                    <div class="col-span-4 text-center">
                        <button
                            class="mr-4 capitalize text-color-text lg:text-sm"
                            on:click={() => {
                                clearFilterGroup(filter.id);
                            }}>Clear</button
                        >
                    </div>
                    <div class="col-span-8">
                        <Button style="Primary" size="Small" onclick={() => (filterDrawerOpen = '')}>View Results</Button>
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/each}

{#if filterDrawerOpen.length}
    <style>
        body {
            overflow: hidden !important;
        }
    </style>
{/if}

<style>
    @media only screen and (max-width: 728px) {
        .draw-bottom {
            width: 100%;
            bottom: -100%;
            transition: bottom 0.4s cubic-bezier(0.82, 0.085, 0.395, 0.895);
        }
        .draw-bottom.open {
            bottom: 0px;
        }
    }
    @media only screen and (min-width: 729px) {
        .draw-bottom {
            display: none;
        }
        .draw-bottom.open {
            display: block;
        }
    }
</style>
